import { useSubheader } from "../../../../_metronic/layout"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { ButtonDropdown, FilterCard, LocationMolecule, RadioButtonGroup, SelectInput, TabsWithIcon } from "../../../../component"
import { initialFilterTable } from "../../../../component/atoms/Tabel"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { useLocation } from "react-router"
import { useUrlParam } from "../../../hooks/useUrlParams"
import { useDispatch, useSelector } from "react-redux"
import { clearDataDetail, getAllMitra } from "../../../../redux/actions/MitraAction"
import { RoutesConstants } from "../../../../constants/RoutesConstants"
import { setDataTabMultiple, SetFilterAction } from "../../../../redux/actions/FilterAction"
import { useTranslation } from "react-i18next"
import { Pending } from "./tab/Pending.jsx"
import { LABELING_CONST, ROUTING_STATUS, isFrozen } from "../../../../constants/StringConstant.js"
import { Active } from "./tab/Active.jsx"
import { Rejected } from "./tab/Rejected.jsx"
import { Inactive } from "./tab/Inactive.jsx"
import { getListFarmerV2 } from "../../../../redux/actions/FarmerAction.jsx"
import { getListRegionalSelected } from "../../../../redux/actions/MasterDataAction.jsx"
import { CheckboxAutoCompleted } from "../../../../component/atoms/CheckboxAutoCompleted.jsx"
import { FloatingSelectArea } from "../../../../component/atoms/FloatingSelectArea/index.jsx"
import { Button } from "react-bootstrap"
import { FarmerListModals } from "./components/FarmerListModals.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers.js"
import { FARMER } from "../../../../constants/InitTypeConstants.js"
import swal from "sweetalert"
import { loadUserLogin } from "../../../../config"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants"
import { ROLE_ENUM } from "../../../../constants/RoleConstants"

export function ListFarmer({
  history,
  match: {
    params: { tab }
  }
}) {
  const subHeader = useSubheader()
  const formRef = useRef()
  const location = useLocation()
  const urlParams = useUrlParam()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { General, Farmer, MasterData, Mitralist } = useSelector((state) => state)

  const [search, setSearch] = useState({
    keyword: ""
  })
  const [initialValue, setInitialValue] = useState({
    ...initialFilterTable,
    province_id: "",
    regency_id: "",
    district_id: "",
    sub_district_id: "",
    mitra_status: "",
    keyword: "",
    regional_id: "",
    mitra_id: "",
    label_type: ""
  })
  const [filterOn, setFilterOn] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [reset, setReset] = useState(false)
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [tabActive, setTabActive] = useState(0)
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const isReadOnly = false
  const [mitraStatusSelect, setMitraStatusSelect] = useState()
  const [selectedRegional, setSelectedRegional] = useState([])
  const [listRegional, setListRegional] = useState([])
  const [selectedMitra, setSelectedMitra] = useState()
  const [listMitra, setListMitra] = useState([])
  const [selectedLabelType, setSelectedLabelType] = useState("")
  const [activeFilterAndSearch, setActiveFilterAndSearch] = useState(false)
  const [selectedRegionalUser, setSelectedRegionalUser] = useState()

  const userLogin = JSON.parse(localStorage.getItem("userLogin"))
  const [isSelectable, setIsSelectable] = useState(false)
  const [isFreeze, setIsFreeze] = useState(false)
  const [isBlacklist, setIsBlacklist] = useState(false)
  const [isUnfreeze, setIsUnfreeze] = useState(false)
  const [freezeItems, setFreezeItems] = useState([])
  const [blacklistItems, setBlacklistItems] = useState([])
  const [unfreezeItems, setUnfreezeItems] = useState([])
  const [showFreezeModal, setShowFreezeModal] = useState(false)
  const [showBlacklistModal, setShowBlacklistModal] = useState(false)
  const [showUnfreezeModal, setShowUnfreezeModal] = useState(false)
  const privileges = loadUserLogin().privilege
  const role = loadUserLogin()?.role

  useEffect(() => {
    if (userLogin?.regional_id) {
      setSelectedRegionalUser(userLogin?.regional_id)
      setInitialValue({
        regional_id: userLogin?.regional_id,
        keyword: search?.keyword,
        ...initialValue
      })
    }
  }, [])

  useEffect(() => {
    if (listRegional && selectedRegionalUser) {
      const data = listRegional.find((e) => e.value === selectedRegionalUser)
      if (data) {
        setSelectedRegional([data])
      }
    }
  }, [listRegional, selectedRegionalUser])

  useEffect(() => {
    if (tab === ROUTING_STATUS.STATUS_ENUM.ACTIVE) {
      setTabActive(1)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.PENDING) {
      setTabActive(0)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.REJECTED) {
      setTabActive(2)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.INACTIVE) {
      setTabActive(3)
    }
  }, [tab])

  useEffect(() => {
    if (filterOn || isActiveSearch) {
      setActiveFilterAndSearch(true)
    } else {
      setActiveFilterAndSearch(false)
    }
  }, [filterOn, isActiveSearch])

  useEffect(() => {
    if (Mitralist.data) {
      setListMitra(
        Mitralist.data.map((value) => ({
          label: value.name,
          value: value.id_mitra
        }))
      )
    }
  }, [Mitralist.data])

  useEffect(() => {
    dispatch(getListRegionalSelected())
    dispatch(getAllMitra())
  }, [])

  const dropdownMenu = useMemo(() => [
    {
      title: t("label_freeze"),
      icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.PAUSE),
      showed: true,
      disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
      action: () => {
        if (isFreeze) {
          setFreezeItems([])
          setIsSelectable(false)
          setIsFreeze(false)
        } else {
          setIsBlacklist(false)
          setBlacklistItems([])
          setIsUnfreeze(false)
          setUnfreezeItems([])
          setIsFreeze(true)
          setIsSelectable(true)
        }
      }
    },
    {
      title: t("label_blacklist"),
      icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.BLACKLIST),
      showed: true,
      disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
      action: () => {
        if (isBlacklist) {
          setBlacklistItems([])
          setIsSelectable(false)
          setIsBlacklist(false)
        } else {
          setIsFreeze(false)
          setFreezeItems([])
          setIsUnfreeze(false)
          setUnfreezeItems([])
          setIsBlacklist(true)
          setIsSelectable(true)
        }
      }
    },
    {
      title: t("label_unfreeze"),
      icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.UNFREEZE),
      showed: true,
      disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
      action: () => {
        if (isUnfreeze) {
          setUnfreezeItems([])
          setIsSelectable(false)
          setIsUnfreeze(false)
        } else {
          setIsFreeze(false)
          setFreezeItems([])
          setIsBlacklist(false)
          setBlacklistItems([])
          setIsUnfreeze(true)
          setIsSelectable(true)
        }
      }
    }
  ], [isFreeze, isBlacklist, isUnfreeze, t])

  useEffect(() => {
    subHeader.setTitle(t("label_farmer_list"))
    return () => {
      dispatch(clearDataDetail())
    }
  }, [])

  useEffect(() => {
    if (tabActive === 1) {
      if (privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) > -1 && role === ROLE_ENUM.FINANCE) {
        subHeader.setButton(
          <ButtonDropdown variant={"outline-primary"} title={"Actions"} dropdownList={dropdownMenu} />
        )
      }
    } else {
      subHeader.setButton(null)
    }
  }, [isSelectable, isFreeze, isBlacklist, isUnfreeze, tabActive, dropdownMenu])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General.actionInitType === FARMER.FREEZE_FARMER) {
      swal(t("messages_response_success_freeze_farmer"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_FREEZE_FARMER
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === FARMER.BLACKLIST_FARMER) {
      swal(t("messages_response_success_blacklist_farmer"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_BLACKLIST_FARMER
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === FARMER.UNFREEZE_FARMER) {
      swal(t("messages_response_success_unfreeze_farmer"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_UNFREEZE_FARMER
      }).then(() => {
        history.replace(0)
      })
    }
  }, [General.isFinishUpdateOrDelete, General.actionInitType])

  useEffect(() => {
    if (MasterData?.listRegionalSelected) {
      setListRegional(
        MasterData.listRegionalSelected.map((item) => {
          return {
            label: item.name + " (" + item.code + ")",
            value: item.id
          }
        })
      )
    }
  }, [MasterData?.listRegionalSelected])

  useEffect(() => {
    if (
      formRef.current.values.province_id ||
      formRef.current.values.mitra_status ||
      formRef.current.values.mitra_id ||
      selectedLabelType ||
      selectedMitra ||
      (selectedRegional && selectedRegional.length)
    )
      setBtnFilterDisable(false)
    else setBtnFilterDisable(true)
  }, [formRef?.current?.values, mitraStatusSelect, selectedMitra, selectedRegional, selectedLabelType])

  function splitDataStringRegionalId(str) {
    if (str) {
      return str.split(",")
    } else {
      return ""
    }
  }

  function filterDataRegional(data) {
    return listRegional.filter((item) => data.includes(item.value)) || []
  }

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
    if (
      queryStringObj?.province_id ||
      queryStringObj?.regency_id ||
      queryStringObj?.district_id ||
      queryStringObj?.sub_district_id ||
      queryStringObj?.mitra_status ||
      queryStringObj?.regional_id ||
      queryStringObj?.mitra_id ||
      queryStringObj?.label_type
    ) {
      if (userLogin?.regional_id) {
        if (
          queryStringObj?.province_id ||
          queryStringObj?.regency_id ||
          queryStringObj?.district_id ||
          queryStringObj?.sub_district_id ||
          queryStringObj?.mitra_status ||
          queryStringObj?.mitra_id ||
          queryStringObj?.label_type
        ) {
          setFilterOn(true)
        } else {
          setFilterOn(false)
        }
      } else {
        setFilterOn(true)
      }
      const data = {
        ...initialFilterTable,
        keyword: queryStringObj?.keyword,
        province_id: queryStringObj?.province_id,
        regency_id: queryStringObj?.regency_id,
        district_id: queryStringObj?.district_id,
        sub_district_id: queryStringObj?.sub_district_id,
        mitra_status: queryStringObj?.mitra_status,
        mitra_id: queryStringObj?.mitra_id,
        regional_id: queryStringObj?.regional_id,
        label_type: queryStringObj?.label_type
      }

      if (data) {
        setInitialValue(data)
        setSearch({ keyword: queryStringObj?.keyword })

        setSelectedRegional(filterDataRegional(splitDataStringRegionalId(data.regional_id)))
        setSelectedMitra(data.mitra_id)
        setMitraStatusSelect(data?.mitra_status)
        setSelectedLabelType(data?.label_type || "")
      }
    }
  }, [queryStringObj, dispatch, listRegional])

  function checkRegionalSelected() {
    if (userLogin?.regional_id) {
      return userLogin?.regional_id
    } else {
      if (selectedRegional) {
        const data = selectedRegional.map((e) => {
          return e.value
        })
        if (data.length > 0) {
          return data.join(",")
        }
      }
    }
  }

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  const fetchData = (param) => {
    if (userLogin?.regional_id) {
      if (param === "" || param === null) param = param + "?regional_id=" + userLogin?.regional_id
    }
    return dispatch(getListFarmerV2(tab, param))
  }

  // search
  const searchFunc = (values) => {
    setSearch({ keyword: values.keyword })
    setIsActiveSearch(true)
    let param = {
      ...initialFilterTable,
      ...initialValue,
      keyword: values.keyword
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleReset = () => {
    let param = {
      ...initialFilterTable,
      ...initialValue,
      keyword: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ keyword: "" })
    setSelectedMitra(undefined)
    setSelectedRegional([])
    setIsActiveSearch(false)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  // filter
  const filterComponent = (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_regional")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <CheckboxAutoCompleted
              disable={!!selectedRegionalUser}
              options={listRegional ?? []}
              onChange={(e) => setSelectedRegional(e)}
              value={selectedRegional || []}
              label={t("label_regional_name")}
              placeholder={t("placeholder_insert_regional_name")}
            />
          </RowModule>
        </CardBody>
      </Card>

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_mitra")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="mitra_id"
              editable={!isReadOnly}
              label={t("label_mitra_name")}
              placeholder={t("placeholder_select_one")}
              options={listMitra}
              withoutFeedback={true}
              clearNow={true}
              value={selectedMitra}
              onChange={(e) => setSelectedMitra(e)}
            />
          </RowModule>
        </CardBody>
      </Card>
      <LocationMolecule
        resetLocation={reset}
        regionalId={checkRegionalSelected()}
        name="filter"
        withoutFeedback={true}
        isReadOnly={isReadOnly}
        addressTitle={t("label_location")}
        removeHorizontalPadding={true}
      />

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_kemitraan_status")} className="px-0" />
        <CardBody className="px-0">
          <RadioButtonGroup
            editable={true}
            label={t("label_freeze")}
            value={LABELING_CONST.FROZEN}
            onClick={() => setSelectedLabelType(LABELING_CONST.FROZEN)}
            checked={selectedLabelType === LABELING_CONST.FROZEN}
            name="label_type"
          />
          <RadioButtonGroup
            editable={true}
            label={t("label_blacklist")}
            value={LABELING_CONST.BLACKLISTED}
            onClick={() => setSelectedLabelType(LABELING_CONST.BLACKLISTED)}
            checked={selectedLabelType === LABELING_CONST.BLACKLISTED}
            name="label_type"
          />
        </CardBody>
      </Card>
    </>
  )
  const onSubmitForm = (e) => {
    setReset(false)
    const { values, submited } = e
    if (submited === true) {
      let param = {
        ...initialFilterTable,
        province_id: values.province_id,
        regency_id: values.regency_id,
        district_id: values.district_id,
        sub_district_id: values.sub_district_id,
        keyword: search.keyword,
        mitra_status: values.mitra_status,
        mitra_id: values?.mitra_id,
        regional_id: selectedRegionalUser ? selectedRegionalUser : checkRegionalSelected(),
        label_type: selectedLabelType
      }
      if (param) {
        setInitialValue(param)
        setSelectedRegionalUser(userLogin?.regional_id)

        const urlParam = getUrlParsingPageFilter(param)
        history.push({ pathname: location.pathname, search: urlParam })
        setShowFilter(false)
        setFilterOn(true)
      }
    }
  }
  useEffect(() => {
    if (selectedRegionalUser) {
      const param = {
        ...initialFilterTable,
        ...initialValue,
        regional_id: selectedRegionalUser,
        keyword: urlParams?.getUrlParamsObj?.keyword,
        province_id: urlParams?.getUrlParamsObj?.province_id,
        regency_id: urlParams?.getUrlParamsObj?.regency_id,
        district_id: urlParams?.getUrlParamsObj?.district_id,
        sub_district_id: urlParams?.getUrlParamsObj?.sub_district_id,
        mitra_status: urlParams?.getUrlParamsObj?.mitra_status,
        mitra_id: urlParams?.getUrlParamsObj?.mitra_id
      }
      if (param) {
        setInitialValue(param)
        const urlParam = getUrlParsingPageFilter(param)
        history.push({ pathname: location.pathname, search: urlParam })
      }
    }
  }, [selectedRegionalUser, tab])
  const filterOnReset = () => {
    dispatch(SetFilterAction())
    setReset(true)
    setShowFilter(false)
    setFilterOn(false)
    let param = {
      ...initialFilterTable,
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      mitra_id: "",
      keyword: search.keyword,
      mitra_status: "",
      regional_id: selectedRegionalUser ? selectedRegionalUser : "",
      label_type: ""
    }
    setInitialValue(param)
    setSelectedLabelType("")
    setMitraStatusSelect("")
    setSelectedMitra("")
    setSelectedRegional([])
    setSelectedRegionalUser(userLogin?.regional_id || "")

    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleOpenCloseFilter = (value) => {
    setShowFilter(value)
  }

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          keyword: search.keyword
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          keyword: search.keyword
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, search, initialValue]
  )

  const changeTabs = (data) => {
    dispatch(setDataTabMultiple(data))
    setTabActive(data)
    let urlParam = ""
    let param = {
      ...initialValue,
      keyword: search.keyword
    }
    urlParam = getUrlParsingPageFilter(param)
    if (data === 0) {
      history.push(
        RoutesConstants.FARMER.LIST_FARMER(ROUTING_STATUS.STATUS_ENUM.PENDING) + urlParam ?? ""
      )
    } else if (data === 1) {
      history.push(
        RoutesConstants.FARMER.LIST_FARMER(ROUTING_STATUS.STATUS_ENUM.ACTIVE) + urlParam ?? ""
      )
    } else if (data === 2) {
      history.push(
        RoutesConstants.FARMER.LIST_FARMER(ROUTING_STATUS.STATUS_ENUM.REJECTED) + urlParam ?? ""
      )
    } else if (data === 3) {
      history.push(
        RoutesConstants.FARMER.LIST_FARMER(ROUTING_STATUS.STATUS_ENUM.INACTIVE) + urlParam ?? ""
      )
    }
  }

  const handleSelectionChange = useCallback((rows) => {
    if (isFreeze) {
      setFreezeItems(rows)
    } else if (isBlacklist) {
      setBlacklistItems(rows)
    } else if (isUnfreeze) {
      setUnfreezeItems(rows)
    }
  }, [isFreeze, isBlacklist, isUnfreeze])

  const getTabsContents = () => {
    const labelList = [
      {
        label: t("label_pending"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_active"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_reject"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_inactive"),
        labelTooltip: "",
        icon: ""
      }
    ]
    const ComponentsList = [
      <Pending
        key={0}
        data={Farmer}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />,
      <Active
        key={1}
        data={Farmer}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
        isMultiSelect={isSelectable}
        actionType={isFreeze ? LABELING_CONST.FREEZE : isBlacklist ? LABELING_CONST.BLACKLIST : isUnfreeze ? LABELING_CONST.UNFREEZE : null}
        onSelectionChange={handleSelectionChange}
      />,
      <Rejected
        key={2}
        data={Farmer}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />,
      <Inactive
        key={3}
        data={Farmer}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />
    ]

    return {
      labels: labelList,
      contents: ComponentsList
    }
  }

  return (
    <>
      <FilterCard
        // seacrh
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_search_farmer_name_or_id")}
        onSubmitForm={searchFunc}
        initialValues={search}
        name={"keyword"}
        innerRef={formRef}
        trigerReset={handleReset}
        // filter
        filterInnerRef={formRef}
        filterHandleSubmit={onSubmitForm}
        filterFormInitialValues={initialValue}
        filterComponent={filterComponent}
        filterOnReset={filterOnReset}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}></FilterCard>

      <TabsWithIcon
        labelTab={getTabsContents().labels}
        componentTab={getTabsContents().contents}
        changeTab={changeTabs}
        initValue={tabActive}
      />
      {(isSelectable && isFreeze) ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_farmer")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.FARMER_GREEN)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsFreeze(false)
                  setIsSelectable(false)
                  setFreezeItems([])
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={freezeItems.length === 0}
                onClick={() => setShowFreezeModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_freeze")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {freezeItems.length} {t("label_farmer")}
            </div>
          }
        />
      ) : <></>}
      {(isSelectable && isBlacklist) ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_farmer")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.FARMER_GREEN)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsBlacklist(false)
                  setIsSelectable(false)
                  setBlacklistItems([])
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={blacklistItems.length === 0}
                onClick={() => setShowBlacklistModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_blacklist")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {blacklistItems.length} {t("label_farmer")}
            </div>
          }
        />
      ) : <></>}
      {(isSelectable && isUnfreeze) ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_farmer")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.FARMER_GREEN)}
          customButtonSection={() => {
            const frozenItems = unfreezeItems.filter((item) => isFrozen(item.farmer_status))
            const nonFrozenItems = unfreezeItems.filter((item) => !isFrozen(item.farmer_status))
            return (
              <>
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setIsUnfreeze(false)
                    setIsSelectable(false)
                    setUnfreezeItems([])
                  }}
                  className={"d-flex align-items-center ml-4"}>
                  {t("button_batal")}
                </Button>
                <Button
                  variant="primary"
                  disabled={nonFrozenItems.length > 0 || frozenItems.length === 0}
                  onClick={() => setShowUnfreezeModal(true)}
                  className={"d-flex align-items-center ml-4"}>
                  {t("label_unfreeze")}
                </Button>
              </>
            )
          }}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {unfreezeItems.length} {t("label_farmer")}
            </div>
          }
        />
      ) : <></>}
      <FarmerListModals
        showFreezeModal={showFreezeModal}
        showBlacklistModal={showBlacklistModal}
        showUnfreezeModal={showUnfreezeModal}
        freezeItems={freezeItems}
        blacklistItems={blacklistItems}
        unfreezeItems={unfreezeItems}
        onModalClose={() => {
          setShowFreezeModal(false)
          setShowBlacklistModal(false)
          setShowUnfreezeModal(false)
        }}
        onFreezePostSubmit={() => {
          setIsFreeze(false)
          setIsSelectable(false)
          setFreezeItems([])
        }}
        onBlacklistPostSubmit={() => {
          setIsBlacklist(false)
          setIsSelectable(false)
          setBlacklistItems([])
        }}
        onUnfreezePostSubmit={() => {
          setIsUnfreeze(false)
          setIsSelectable(false)
          setUnfreezeItems([])
        }}
      />
    </>
  )
}